module.exports = __webpack_public_path__ + "static/1-asset-3-d@3x-0e8d9f2060debf09c158c8f4ff6ee54c.png";